var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"open-cards-stats"},[_c('ul',_vm._l((_vm.stats),function(stat,index){return _c('OpenCardsStat',{key:index,attrs:{"desc":stat.desc,"value":stat.value}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }